import React, { useContext, useState } from "react";
import { IconButton, Popover } from "@mui/material";
import { styled } from "@mui/system";
import { DEFAULT_MENU_OPTION } from "./../../../constants";
import styles from "./styles.module.css";
import { ThreeDotsIcon } from "../../../assets/icons/icon";
import { UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const CustomPopover = styled("div")(() => ({
  position: "relative",
  background: "#fff",
  borderRadius: "16px",
}));

const PopoverMenu = ({
  menuOptions = DEFAULT_MENU_OPTION,
  buttonStyle = {},
  popOverStyle = {},
  popoverButton,
  popoverButtonClassName,
  className,
  disabled = false,
  closeOnSelect = true,
  actionBtn,
  actionBtnText,
  popoverButtonRestProps,
  popoverPaperClassName,
  UbButtonClass,
  openPopoverClassName,
  handleOpen = () => { },
  id: popOverId = "",
}) => {
  const [I18n] = useContext(LanguageContext);
  const resolvedActionBtnText = actionBtnText || I18n.confirm?.toUpperCase() || "CONFIRM";
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    triggerLogEvent(analytics, "menu_opened", { menu_id: popOverId });
    handleOpen();
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {popoverButton ? (
        <UBButton
          id={`${popOverId}_popoverId`}
          disabled={disabled}
          style={{ ...buttonStyle }}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          className={`cursorPointer ${popoverButtonClassName || styles.menuButton} ${open ? openPopoverClassName : ""}`}
          onClick={handleClick}
          title={popoverButton}
          {...popoverButtonRestProps}
        />
      ) : (
        <IconButton
          id={`${popOverId}_popoverId`}
          aria-describedby={id}
          onClick={handleClick}
          disabled={disabled}
          className={styles.menuButtonIconStyle}
        >
          <ThreeDotsIcon />
        </IconButton>
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className={` actionPopoverWrapper ${styles.popoverMenuWrapper}${className ? ` ${className}` : ""}`}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          className: popoverPaperClassName,
          sx: {
            overflow: "visible",
            mt: 1,
            marginLeft: "0px",
            ...popOverStyle,
          },
        }}
      >
        <CustomPopover>
          <div className={styles.popoverMenu} data-popover-menu>
            {menuOptions.map((option, index) => (
              <div
                id={`${index}_optId`}
                className={`perItem ${styles.perItem} ${option.danger ? styles.perItemDanger : ""}`}
                data-popover-menu-item
                key={index}
                onClick={(e) => {
                  option.action(e);
                  if (closeOnSelect) {
                    handleClose(e);
                  }
                }}
              >
                {option.label}
              </div>
            ))}
            {/* <div className='line' /> */}
          </div>
        </CustomPopover>
        {typeof actionBtn === "function" && (
          <UBButton
            id={`${popOverId}_popoverAction`}
            className={`${UbButtonClass}`}
            title={resolvedActionBtnText}
            onClick={(e) => {
              actionBtn();
              handleClose(e);
            }}
          />
        )}
      </Popover>
    </>
  );
};

export default PopoverMenu;
